import { useRouter } from '@/domains/shared/router/Router';
import { Button } from '@/domains/shared/components/Button';

export function ErrorPage() {
  const { navigate } = useRouter();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-navy px-4 text-center text-brand-offWhite">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-navy-dark p-8 shadow-2xl">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-feedback-danger/20 text-feedback-danger">
          <svg className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>

        <h1 className="text-xl font-bold text-white sm:text-2xl">Ops! Tivemos uma interrupção</h1>

        <p className="mt-3 text-sm text-brand-offWhite/80">
          Não conseguimos processar o diagnóstico neste momento. Suas respostas anteriores continuam seguras no seu navegador.
        </p>

        <div className="mt-6 flex flex-col gap-3">
          <Button variant="primary" onClick={() => navigate('/diagnostico')}>
            Retomar de onde parei
          </Button>
          <Button variant="secondary" onClick={() => navigate('/')}>
            Voltar para o início
          </Button>
        </div>
      </div>
    </div>
  );
}
